import { Link } from "react-router-dom";
import { AlertTriangle, ChevronRight } from "lucide-react";
import { Panel } from "./common";

export function AlertsPanel({ alerts, count, limit = 8 }) {
  return (
    <Panel testid="alerts-panel" bodyClass="p-0"
      title={<span className="flex items-center gap-2">Alerts <span className="rounded-full bg-primary px-2 py-0.5 text-xs text-primary-foreground font-figure" data-testid="alerts-count">{count}</span></span>}
      actions={<Link to="/checks" className="text-xs font-semibold text-primary hover:underline" data-testid="alerts-see-all-link">See all checks</Link>}>
      <p className="px-5 md:px-6 pt-4 text-sm text-muted-foreground">{count} projects have at least one check that doesn't agree.</p>
      <ul className="divide-y mt-2">
        {alerts.slice(0, limit).map((a) => (
          <li key={a.id}>
            <Link to={`/projects/${a.id}`} className="flex items-start gap-3 px-5 md:px-6 py-3 hover:bg-muted/60 transition-colors" data-testid={`alert-item-${a.id}`}>
              <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-[hsl(var(--warning))]" />
              <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-semibold">{a.name}</div>
                <div className="truncate text-xs text-muted-foreground">{a.partner_name} · {a.issues.join(" · ")}</div>
              </div>
              <span className="font-figure text-xs font-bold text-primary">{a.flags}</span>
              <ChevronRight className="h-4 w-4 text-muted-foreground" />
            </Link>
          </li>
        ))}
      </ul>
    </Panel>
  );
}
